<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add device' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="deviceForm" class="row add-premise-form">
      <div class="col-12">
        <div class="form-group">
          <label>{{ 'Belongs to premise' | translate }}:</label>
          <select
            class="form-control"
            formControlName="businessPremiseId"
            [class.is-invalid]="
              sent && deviceForm.get('businessPremiseId').errors
            "
          >
            <option [ngValue]="null">{{ 'global.select.please-select' | translate }}</option>
            <option *ngFor="let premise of premises" [ngValue]="premise.id">
              {{ premise.businessPremiseId }}
            </option>
          </select>
          <div
            class="invalid-feedback"
            *ngIf="
              sent && deviceForm.get('businessPremiseId').hasError('required')
            "
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
        </div>
        <div class="form-group">
          <label>{{ 'Device ID' | translate }}</label>
          <input
            type="text"
            class="form-control"
            formControlName="electronicDeviceId"
            placeholder="D1"
            [class.is-invalid]="
              sent && deviceForm.get('electronicDeviceId').errors
            "
          />
          <div
            class="invalid-feedback"
            *ngIf="
              sent && deviceForm.get('electronicDeviceId').hasError('required')
            "
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
          <div
            class="invalid-feedback"
            *ngIf="
              sent && deviceForm.get('electronicDeviceId').hasError('pattern')
            "
          >
            {{ 'furs.electronic-device-add.businessPremiseId.invalid-format' | translate }}
          </div>
        </div>
        <div class="form-group" *ngIf="strategy === 'B'">
          <label>{{ 'Invoice first number' | translate }}</label>
          <input
            type="number"
            min="1"
            formControlName="lastNumber"
            class="form-control"
            placeholder="1"
            [class.is-invalid]="sent && deviceForm?.hasError('lastNumber')"
          />
          <div
            class="invalid-feedback"
            *ngIf="sent && deviceForm?.hasError('lastNumber')"
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      <span>{{ 'global.save' | translate }}</span>
      <!-- <span *ngIf="context.client.id">{{ 'Update' | translate }}</span> -->
      <span *ngIf="loading"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
